<template>
  <div>
    <b-row>
      <b-col md="12">
        <b-card>
          <div slot="header">
            <strong>
              <div>회원가입안내 정보</div>
            </strong>
          </div>
          <div class="table-responsive-sm">
            <table class="table b-table table-striped">
                <tbody class="">
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                    <td width="150" style="background-color:#f1f1f1">
                      <label class="col-form-label">등록일</label>
                    </td>
                    <td class="" style="vertical-align:middle">{{joinGuideDatas.reg_date}}</td>
                  </tr>

                  <!-- <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                    <td width="150" style="background-color:#f1f1f1">
                      <label class="col-form-label">노출여부</label>
                    </td>
                    <td class="">
                      <label class="col-form-label">
                        <b-form-radio-group id="basicCustomUseyn" name="useyn">
                          <div class="custom-control custom-radio custom-control-inline">
                            <input type="radio" id="useY" name="useyn" disabled class="custom-control-input" v-model="joinGuideDatas.use_yn" value="Y">
                            <label class="custom-control-label" for="useY">노출</label>
                          </div>
                          <div class="custom-control custom-radio custom-control-inline">
                            <input type="radio" id="useN" name="useyn" disabled class="custom-control-input" v-model="joinGuideDatas.use_yn" value="N">
                            <label class="custom-control-label" for="useN">비노출</label>
                          </div>
                        </b-form-radio-group>
                      </label>
                    </td>
                  </tr> -->
                  <!-- <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                    <td width="150" style="background-color:#f1f1f1">
                      <label class="col-form-label">문의종류</label>
                    </td>
                    <td class="" style="vertical-align:middle">{{joinGuideDatas.type_name}}</td>
                  </tr> -->
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                    <td width="150" style="background-color:#f1f1f1">
                      <label class="col-form-label">제목</label>
                    </td>
                    <td class="" style="vertical-align:middle">{{joinGuideDatas.title}}</td>
                  </tr>
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                    <td width="150" style="background-color:#f1f1f1">
                      <label class="col-form-label">내용</label>
                    </td>
                    <td class="" style="vertical-align:middle"><div v-html="joinGuideDatas.contents"></div></td>
                  </tr>
                </tbody>
            </table>
          </div>
        </b-card>
      </b-col>
      <b-col md="12">
        <b-row style="margin-bottom:1.5em">
          <b-col sm="3" lg="4">
            &nbsp;
          </b-col>
          <b-col sm="3" lg="4">
            &nbsp;
          </b-col>
          <b-col sm="3" lg="4">
            <div style="float:right; width:70%">
              <b-row>
                <b-col md="4">
                  <b-button variant="danger" style="color:#ffffff; border-radius:5px; cursor:pointer; width:100%; border:1px solid #f42f2d; font-size:15px" v-on:click="joinGuideDelete(joinGuideCode)"><h5 style="margin-bottom:0px"><i class="fa fa-remove"></i> 삭제</h5></b-button>
                </b-col>
                <b-col md="4">
                  <b-button variant="warning" style="color:#ffffff; border-radius:5px; cursor:pointer; width:100%; border:1px solid #c5940d; font-size:15px" v-bind:href="'#/customer/joinguide/form?status=update'"><h5 style="margin-bottom:0px"><i class="fa fa-edit"></i> 수정</h5></b-button>
                </b-col>
                <b-col md="4">
                  <b-button variant="primary" style="color:#ffffff; border-radius:5px; cursor:pointer; width:100%; border:1px solid #187c9f; font-size:15px" v-bind:href="'#/customer/joinguide'"><i class="fa fa-list-ul"></i> 목록</h5></b-button>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import cSwitch from '../../components/Switch';
import swal from 'sweetalert2'

export default {
  components: {
    cSwitch,
  },
  data() {
    return {
      joinGuideCode: '',
      drDeleteRows: [],
      joinGuideDatas: {
        attachmentFileItems:[],
      },
    }
  },
  watch: {},
  mounted: function() {
    var token = sessionStorage.getItem("myToken");
    var self = this;
    self.joinGuideCode = self.$session.get('joinGuideCode');
    console.log("self.joinGuideCode",self.joinGuideCode)
    if(self.joinGuideCode != undefined){
      self.getJoinGuideData(self.joinGuideCode);
    }
  },
  methods: {
    // 회원가입안내 데이터 조회
    getJoinGuideData(joinGuideCode) {
      var token = sessionStorage.getItem("myToken");
      var self = this;
      self.$http.get('/api/select/joinGuideData?access_token=' + token + '&joinGuideCode=' + joinGuideCode)
      .then((result) => {
        self.joinGuideDatas = result.data;
      })
    },
    joinGuideDelete(drCodeDel){
      var self = this;
      self.drDeleteRows = [];
      swal.fire({
        title: '회원가입안내 삭제!',
        // text: "기본정보 이외에 작성한 데이터는 모두 초기화 됩니다. "+messageValue+"로 변경하시겠습니까?",
        html: "현재 회원가입안내의 저장된 데이터</br> 모두 삭제 됩니다. 삭제하시겠습니까?",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'OK'
      }).then((swalResult) => {
        if (swalResult.value) {
          // ok
          self.drDeleteRows.push(drCodeDel);
          var token = sessionStorage.getItem("myToken");
          var param = encodeURI(JSON.stringify(self.drDeleteRows));
          var data = new FormData();
          data.append('drDelArr', param);

          self.$http.post('/api/delete/joinGuideData?access_token='+token, data, null)
            .then((result) => {
              swal.fire({
                type: 'success',
                title: '회원가입안내이 삭제되었습니다.',
                showConfirmButton: false,
                timer: 1000
              }).then(function() {
                  window.location = "#/customer/joinguide";
              });
          })
        }else{
          // cansel
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/customer/JoinGuideInfo.vue